import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

function CenterLayout(props) {
  const { children, padded, body } = props;
  return (
    <div
      className={cx("container mx-auto", { "p-4": padded }, { "py-4": body })}
    >
      {children}
    </div>
  );
}

CenterLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  padded: PropTypes.bool,
  body: PropTypes.bool,
};

CenterLayout.defaultProps = {
  padded: true,
  body: true,
};

export default CenterLayout;
